/* tslint:disable */
/* eslint-disable */
/**
 * Generated by OpenAPI Generator (https://openapi-generator.tech)
 *
 * Do not edit manually.
 */


/**
 * 
 * @export
 */
export const DefaultBasePermission = {
    VIEW_HELP_CENTER: 'view:help_center',
    CREATE_COMPLETION: 'create:completion',
    CREATE_DOCUMENT_QA: 'create:document_qa',
    CREATE_ADVANCED_DOC_QA: 'create:advanced_doc_qa',
    CREATE_MULTI_DOC_QA: 'create:multi_doc_qa',
    USE_ASSISTANT_V2: 'use:assistant_v2',
    CREATE_ASSISTANT_DRAFT: 'create:assistant_draft',
    READ_HISTORY: 'read:history',
    CREATE_FEEDBACK: 'create:feedback',
    CREATE_PRIVATE_LIBRARY_PROMPTS: 'create:private_library_prompts',
    USE_LIBRARY_EXAMPLES: 'use:library_examples',
    CREATE_USER_LIBRARY_ITEMS: 'create:user_library_items',
    CREATE_TRANSLATION: 'create:translation',
    CREATE_REDLINES: 'create:redlines',
    CREATE_SEC_EDGAR_QA: 'create:sec_edgar_qa',
    USE_ASSISTANT_RESEARCH_KS: 'use:assistant_research_ks',
    CREATE_USER_PROFILES: 'create:user_profiles',
    CREATE_USER_PROFILES_OPTIONAL_STEPS: 'create:user_profiles_optional_steps',
    USE_ASSISTANT_LOCALIZATION: 'use:assistant_localization',
    USE_SHAREPOINT_INTEGRATION: 'use:sharepoint_integration',
    USE_GOOGLE_DRIVE_INTEGRATION: 'use:google_drive_integration',
    USE_HARVEY_FOR_WORD: 'use:harvey_for_word',
    USE_ASSISTANT_COMPOSER: 'use:assistant_composer',
    CREATE_VAULT: 'create:vault',
    CREATE_VAULT_SHARES: 'create:vault_shares',
    USE_VAULT_SHARING: 'use:vault_sharing',
    CREATE_EVENT_SHARES: 'create:event_shares',
    USE_EVENT_SHARING: 'use:event_sharing',
    USE_KNOWLEDGE_BASE_PROJECT: 'use:knowledge_base_project',
    USE_DISCOVER_TAB: 'use:discover_tab'
} as const;
export type DefaultBasePermission = typeof DefaultBasePermission[keyof typeof DefaultBasePermission];


export function instanceOfDefaultBasePermission(value: any): boolean {
    for (const key in DefaultBasePermission) {
        if (Object.prototype.hasOwnProperty.call(DefaultBasePermission, key)) {
            if (DefaultBasePermission[key as keyof typeof DefaultBasePermission] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DefaultBasePermissionFromJSON(json: any): DefaultBasePermission {
    return DefaultBasePermissionFromJSONTyped(json, false);
}

export function DefaultBasePermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): DefaultBasePermission {
    return json as DefaultBasePermission;
}

export function DefaultBasePermissionToJSON(value?: DefaultBasePermission | null): any {
    return value as any;
}

export function DefaultBasePermissionToJSONTyped(value: any, ignoreDiscriminator: boolean): DefaultBasePermission {
    return value as DefaultBasePermission;
}

